__webpack_require__.p = "https://partnership-mpos-frontend-prod.ackoassets.com/next_assets/9fd8261648399ac4a595a33c2cd5acfc21397c24/_next/";